import axiosBaseService from './base-axios-api'
import BaseApi from './base-api';

export const filesApi = new BaseApi('api/files');

filesApi.getFiles = function (u = '', q) {
    return axiosBaseService({
        url: this.composeUrl(this.url, '/upload', u),
        method: 'get',
        withCredentials: false,
        params: q
    })
}

filesApi.uploadFiles = function (u = '', m, onUploadProgressAction) {
    return axiosBaseService({
        url: this.composeUrl(this.url, '/upload', u),
        method: 'post',
        withCredentials: false,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: onUploadProgressAction,
        data: m
    })
}

filesApi.downloadFile = function (u = '') {
    return axiosBaseService({
        url: this.composeUrl(this.url, '/download', u),
        method: 'get',
        withCredentials: false,
        responseType: 'blob'
    })
}
